import { ChangeDetectionStrategy, Component, input, model, output } from "@angular/core";
import { TypeManagerDecorator } from "../../main/type.map.service";
import { S25MultiselectModule } from "../../modules/s25-multiselect/s25-multiselect.module";
import { MultiselectModelI } from "../../modules/s25-multiselect/s25.multiselect.component";
import { S25ItemI } from "../../pojo/S25ItemI";

@TypeManagerDecorator("s25-ng-occurrence-schedule-locations-cell")
@Component({
    selector: "s25-ng-occurrence-schedule-locations-cell",
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [S25MultiselectModule],
    template: `
        <div class="occurrence-schedule-locations-cell">
            @if (!selectedItems()?.length) {
                <span class="occurrence-schedule-locations-cell__empty ngFinePrint"
                    >No locations for this occurrence</span
                >
            }
            @if (pickerBean()) {
                <s25-ng-multiselect-search-criteria
                    [type]="'locations'"
                    [buttonText]="'Add locations'"
                    [modelBean]="pickerBean()!"
                    [(value)]="selectedItems"
                    [showResults]="true"
                    [popoverOnBody]="true"
                    (close)="pickerClose.emit($event)"
                    (changed)="selectionChanged.emit($event)"
                />
            }
            @if (isCustomized()) {
                <span class="occurrence-schedule-locations-cell__customized ngFinePrint"
                    >Customized for this occurrence</span
                >
            }
        </div>
    `,
    styles: `
        .occurrence-schedule-locations-cell {
            display: flex;
            flex-direction: column;
            gap: 0.35rem;
        }

        .occurrence-schedule-locations-cell__chips {
            display: flex;
            flex-wrap: wrap;
            gap: 0.25rem;
        }

        .occurrence-schedule-locations-cell__customized {
            font-style: italic;
        }
    `,
})
export class S25OccurrenceScheduleLocationsCellComponent {
    readonly selectedItems = model<S25ItemI[]>([]);
    readonly pickerBean = input<MultiselectModelI | undefined>(undefined);
    readonly isCustomized = input(false);

    readonly selectionChanged = output<S25ItemI[]>();
    readonly pickerClose = output<S25ItemI[]>();
}
